<template>
  <v-checkbox
    class="imd-sm-input-chkbox"

    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>

  </v-checkbox>
</template>
<style>
/* 중간정렬 */
.imd-sm-input-chkbox { vertical-align: middle; }
/* wrap */
.imd-sm-input-chkbox.v-input--selection-controls { overflow: visible; height: unset;  margin:-1px 6px -14px 0px; padding:0; }
/* 아이콘 */
.imd-sm-input-chkbox .v-icon { font-size: 21px; margin-top: -3px;}
.imd-sm-input-chkbox .v-input--selection-controls__input { margin: 0 1px 0 0; }
/* 라벨 */
.imd-sm-input-chkbox .v-label { font-size: 12px; font-Family: Gulim, '굴림', dotum,'돋움', AppleGothic, sans-serif; margin-top: -2px; }
/* 클릭했을때 번쩍이는 효과 범위 */
.imd-sm-input-chkbox .v-input--selection-controls__ripple {
    height: 22px;
    width: 22px;
    left: -8px;
    top: calc(50% - 18px);
}
/* 안쓰는 부분 */
.imd-sm-input-chkbox .v-messages { display: none; }

</style>

<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'inputValue',
    event: 'change'
  },
}
</script>
